import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonServiceService } from '../services/common-service.service';
import { Router, ActivatedRoute } from '@angular/router';
import { mustMatch } from '../sign-up/register/must-watch.validators';
import { AlertService } from '../alert/alert.service';
import * as $ from 'jquery';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
  passwordForm: FormGroup;
  submitted = false;
  closeResult: string = '';
  params: string = '';
  notFocused = false;
  options = {
    autoClose: false,
    keepAfterRouteChange: false
  };
  
  constructor(private formBuilder: FormBuilder,
    private service: CommonServiceService,
    private router: Router,
    private activatedRoute:ActivatedRoute, public alertService: AlertService) { }

  ngOnInit(): void {
    $('#hiddensm').hide();
    this.passwordForm = this.formBuilder.group({
      password: ['', [Validators.required, Validators.minLength(8)]],
      passwordConfirmation: ['',Validators.required]
    }, {
        validator: mustMatch('password', 'passwordConfirmation')
    });
    this.activatedRoute.queryParams.subscribe(params => {
      if(params.token && params.token !== ''){
        this.params = params.token;
      }
    });
  }
  get f() { return this.passwordForm.controls; }
  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.passwordForm.invalid) {
        return;
    }
    const _data = {
      new_password: this.passwordForm.value.password,
      token: this.params
    };
    this.service.setPassword(_data)
    .subscribe(
        result => {
         if(result === 'OK'){
          this.alertService.success('Password changed successfuly', this.options);
          this.router.navigateByUrl('/signin');
         }else{
          this.alertService.error('Reset failed', this.options);
         }
        },
        error => {
          this.alertService.error(JSON.parse(error.error).message, this.options);
        }
    ); 
  }
  onReset() {
    this.submitted = false;
    this.passwordForm.reset();
  }
}
